import { createSlice } from "@reduxjs/toolkit";
import { GetAllClaimDashboard } from "./claimDashboardApi";

// Get current month in YYYY-MM format
const getCurrentMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
};

const ClaimDashboardSlice = createSlice({
    name: "claimDashboard",
    initialState: {
        claimDashboardData: null,
        claimDashboardFilters: {
            branches: [],
            dateRange: [getCurrentMonth(), getCurrentMonth()],
            frm_mnth: getCurrentMonth(),
            to_mnth: getCurrentMonth(),
            top_frm_mnth: getCurrentMonth(),
        },
    },
    reducers: {
        handleClaimDashboardFilter: (state, action) => {
            state.claimDashboardFilters[action?.payload?.check] = action?.payload?.value;
        },
        handleResetClaimDashboardFilter: (state, _) => {
            state.claimDashboardFilters = {
                branches: [],
                dateRange: [getCurrentMonth(), getCurrentMonth()],
                frm_mnth: getCurrentMonth(),
                to_mnth: getCurrentMonth(),
                top_frm_mnth: getCurrentMonth(),
            };
        },
    },
    extraReducers: (builder) => {
        builder.addCase(GetAllClaimDashboard.fulfilled, (state, action) => {
            state.claimDashboardData = action?.payload?.data;
        });
    },
});

export const { handleClaimDashboardFilter, handleResetClaimDashboardFilter } =
    ClaimDashboardSlice.actions;
export default ClaimDashboardSlice.reducer;
